var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscount({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.297,
    height: 9.319,
    viewBox: "0 0 7.297 9.319",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46885",
    "data-name": "Group 46885",
    transform: "translate(-541.432 -465.66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35809",
    "data-name": "Path 35809",
    d: "M5.968,11.441,2,7.473v.811a.8.8,0,0,0,.239.571L5.4,12.012a.812.812,0,0,0,1.147,0L9.06,9.5a.812.812,0,0,0,0-1.147Z",
    transform: "translate(539.432 462.729)",
    fill: "#043f88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35810",
    "data-name": "Path 35810",
    d: "M5.4,7.056a.8.8,0,0,0,1.143,0L9.056,4.539a.812.812,0,0,0,0-1.147L5.9.235A.81.81,0,0,0,5.327,0H2.811A.813.813,0,0,0,2,.811V3.327a.8.8,0,0,0,.239.571ZM2.811.811H5.327L8.484,3.968,5.968,6.484,2.811,3.327Z",
    transform: "translate(539.432 465.66)",
    fill: "#043f88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35811",
    "data-name": "Path 35811",
    d: "M5.013,2.507A.507.507,0,1,1,4.507,2,.507.507,0,0,1,5.013,2.507Z",
    transform: "translate(538.648 464.876)",
    fill: "#043f88"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.282f9404f16987e9abe4b997c4924e84.svg";
export { ForwardRef as ReactComponent };